import { getTranslate } from '@/utils/api-interceptors'
import { useIsomorphicLayoutEffect } from '@/utils/useIsomorphicLayoutEffect'
import { Disclosure, Transition } from '@headlessui/react'
import { useRef, useState } from 'react'

interface InformationType {
  description: {
    vi: string
    en: string
  }
  title: string
}

export const Information = ({ description, title }: InformationType) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const targetRef = useRef<HTMLDivElement>(null) as any
  const [isReadMore, setIsReadMore] = useState(false)
  const [dimensions, setDimensions] = useState(0)

  const toggleReadMore = () => {
    setIsReadMore(!isReadMore)
  }
  useIsomorphicLayoutEffect(() => {
    const timeout = setTimeout(() => {
      if (targetRef.current && description) {
        setDimensions(targetRef.current.clientHeight as number)
      }
    }, 400)
    return () => {
      setDimensions(0)
      setIsReadMore(false)
      if (timeout) {
        clearTimeout(timeout)
      }
      if (targetRef.current && isReadMore) {
        targetRef.current = null
      }
    }
  }, [description])
  return (
    <div className='information '>
      {description && (
        <>
          <h2 className='mb-3 pt-5 text-left text-lg font-semibold text-dark-400'>
            {title}
          </h2>
          <Disclosure defaultOpen={true} as='div' className='flex w-full'>
            {({ open }) => (
              <div className='relative w-full'>
                <Transition
                  show={open}
                  enter='transition duration-1000 ease-out'
                  enterFrom='transform scale-95 opacity-0'
                  enterTo='transform scale-100 opacity-100'
                  leave='transition duration-75 ease-out'
                  leaveFrom='transform scale-100 opacity-100'
                  leaveTo='transform scale-95 opacity-0'
                >
                  <div
                    className={`flex  flex-col items-start overflow-hidden ${
                      isReadMore ? 'max-h-full' : 'max-h-[1200px]'
                    }`}
                  >
                    <div
                      className='main-description break-words'
                      id='description-main'
                      ref={targetRef}
                      dangerouslySetInnerHTML={{
                        __html: getTranslate(description),
                      }}
                    ></div>
                  </div>
                </Transition>
                {!isReadMore && dimensions > 1200 && (
                  <div className='absolute bottom-0 left-0 h-[132px] w-full bg-seeMore bg-bottom'></div>
                )}
              </div>
            )}
          </Disclosure>
          {dimensions < 1200 ? (
            ''
          ) : (
            <div
              className={`relative z-50 flex w-full justify-center ${
                !isReadMore ? '-mt-5' : 'mt-2'
              }`}
            >
              <button
                onClick={toggleReadMore}
                className={`mx-auto flex w-[70%] items-center justify-center gap-x-1 rounded border border-blue-base bg-white px-5 py-2 text-center font-semibold leading-6 text-blue-base hover:bg-blue-base hover:text-white`}
              >
                {!isReadMore ? 'Xem thêm' : 'Thu gọn'}
              </button>
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default Information
